/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import SocketIOClient from 'socket.io-client';
import 'whatwg-fetch';
import 'jspolyfill-array.prototype.find';

import getCurrentGameIndex from './src/utils/get-current-game-index';
import eventTypes from './src/browser/liveticker.events';
import data2list, { findItemIndex, sortEvents } from './src/browser/liveticker.data';


// const apiServer = 'https://staging.mwd-agentur.de/ebb/web/index.php';
const apiServer = 'https://app.eisbaeren.de/';
// const apiServer = '/index.php';

// const socketServer = 'https://ebb-socket-proy.now.sh';
const socketServer = 'https://appticker.eisbaeren.de';
// const socketServer = 'http://0.0.0.0:8888';

let socketStore = [];
let socket;
let game;
let sponsor;
let players;
let liveticker;

const apiRequest = endpoint => window.fetch(`${apiServer}index.php?r=output%2F${endpoint}`, {
  mode: 'cors',
}).then(res => res.json());

const loadGames = id => apiRequest(`games&id=${id}`);

const loadPlayers = () => apiRequest('player');

const loadLiveticker = () => apiRequest('liveticker');

const applyScore = (goals) => {
  const homeEl = document.querySelector('.top-game .score.home');
  const visitorEl = document.querySelector('.top-game .score.visitor');
  if (game.home_away === 'Home') {
    homeEl.textContent = goals.berlin;
    visitorEl.textContent = goals.opponent;
  }
  else {
    homeEl.textContent = goals.opponent;
    visitorEl.textContent = goals.berlin;
  }
};

const updateTopGame = () => {
  const homeLogo = document.querySelector('.top-game .logo.home');
  const visitorLogo = document.querySelector('.top-game .logo.visitor');
  homeLogo.style.backgroundImage = `url(${apiServer}${game.home.logo})`;
  visitorLogo.style.backgroundImage = `url(${apiServer}${game.visitor.logo})`;

  const homeName = document.querySelector('.top-game .name.home');
  const visitorName = document.querySelector('.top-game .name.visitor');
  homeName.textContent = game.home.name;
  visitorName.textContent = game.visitor.name;

  const locationEl = document.querySelector('.top-game .location');
  locationEl.textContent = game.home_away;

  const contestEl = document.querySelector('.top-game .contest');
  contestEl.textContent = `${game.misc}`;

  const dateEl = document.querySelector('.top-game .date');
  dateEl.textContent = `${game.season}`;

  const sponsorEl = document.querySelector('.presented-by img');
  sponsorEl.src = `${apiServer}${sponsor}`;
};

const appUpdate = (data) => {
  socketStore.push(data);
  // socketStore = socketStore.slice(-500);

  // console.info('appupdate event', data);
  liveticker = data2list(socketStore);

  updateTopGame();

  fillContent();

  const lastGoal = liveticker.find(item => item.updateType === 'goal');
  if (!lastGoal) return;
  applyScore(lastGoal.goals);
};

const fillContent = () => {
  const container = document.getElementById('liveticker-events');
  if (!container) throw new Error('Could not find container for events');
  // console.info('fillContent', container, game);

  container.innerHTML = liveticker
    .map(item => {
      return `<section class="liveticker-event ${item.updateType}">
        ${eventTypes[item.updateType](item, game, players)}
      </section>`;
    })
    .join('');
};

exports.onInitialClientRender = () => {
  socket = SocketIOClient(`${socketServer}/`);
  socket.on('appupdate', appUpdate);

  Promise.all([
    loadPlayers(),
    loadLiveticker(),
  ])
    .then(([playersData, livetickerData]) => {
      const { events, gameId } = livetickerData;

      sponsor = livetickerData.sponsor;
      players = playersData.players;
      socketStore = events;
      liveticker = data2list(events);

      // const currentGameIndex = gamesData.findIndex(item => `${item.id}` === `${gameId}`);
      // game = games[currentGameIndex];

      return loadGames(gameId)
        .then((currentGame) => {
          game = currentGame.pop();

          updateTopGame();

          fillContent();

          const lastGoal = liveticker.find(item => item.updateType === 'goal');
          if (!lastGoal) return;
          applyScore(lastGoal.goals);
        });
    })
    .catch(err => console.warn(err.stack));
};

// exports.shouldUpdateScroll = () => console.info('shouldUpdateScroll');

// exports.onClientEntry = () => console.info('onClientEntry');



// WEBPACK FOOTER //
// ./gatsby-browser.js